const customerApi = import.meta.env.VITE_CUSTOMER_API_URL || '/backend/customer-api.php';

/** Error carrying the API's message plus optional per-field details. */
export class CustomerApiError extends Error {
  constructor(message, { status = 0, code = '', fields = {}, devLink = '' } = {}) {
    super(message);
    this.name = 'CustomerApiError';
    this.status = status;
    this.code = code;
    this.fields = fields;
    this.devLink = devLink;
  }
}

async function call(action, body = null) {
  const isGet = body === null;
  let response;
  try {
    response = await fetch(isGet ? `${customerApi}?action=${encodeURIComponent(action)}` : customerApi, {
      method: isGet ? 'GET' : 'POST',
      credentials: 'include',
      headers: isGet ? undefined : { 'Content-Type': 'application/json' },
      body: isGet ? undefined : JSON.stringify({ action, ...body }),
    });
  } catch {
    throw new CustomerApiError('Cannot reach the server. Check your connection and try again.');
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    // fall through with the empty payload
  }

  if (!response.ok) {
    throw new CustomerApiError(payload.error || 'Something went wrong. Please try again.', {
      status: response.status,
      code: payload.code || '',
      fields: payload.fields || {},
      devLink: payload.devLink || '',
    });
  }

  return payload;
}

export const customerService = {
  me: () => call('me'),
  countries: () => call('countries'),
  myOrders: () => call('my-orders'),
  register: ({ name, email, password }) => call('register', { name, email, password }),
  verifyEmail: (token) => call('verify-email', { token }),
  resendVerification: (email) => call('resend-verification', { email }),
  login: ({ email, password }) => call('login', { email, password }),
  logout: () => call('logout', {}),
  forgotPassword: (email) => call('forgot-password', { email }),
  resetPassword: ({ token, password }) => call('reset-password', { token, password }),
  updateProfile: (profile) => call('update-profile', profile),
  updateAddresses: ({ billing, shipping }) => call('update-addresses', { billing, shipping }),
  changePassword: ({ currentPassword, newPassword }) => call('change-password', { currentPassword, newPassword }),
};
